import { useFormContext } from "react-hook-form";

import { Combobox } from "@/components/ui/combobox";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";

import { type FormControlProps } from "./types";

export const AutoCompleteControl = ({ field, name }: FormControlProps) => {
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={name}
      render={(context) => (
        <FormItem>
          <FormLabel>{field.title}</FormLabel>
          <FormControl>
            <Combobox
              value={context.field.value as string}
              onChange={context.field.onChange}
              options={field.options.map((option) => ({
                value: option.key,
                label: option.value,
              }))}
              placeholder={field.title}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
